import { render } from "./ScanComponent.vue?vue&type=template&id=2e47ece8"
import script from "./ScanComponent.vue?vue&type=script&lang=ts"
export * from "./ScanComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script